import {
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Portal,
} from "@chakra-ui/react";
import { InfoCircleIcon } from "shared/icons/InfoCircleIcon";

export const InfoTooltip: React.FC<React.PropsWithChildren> = ({
  children,
}) => (
  <Popover trigger="hover" placement="top">
    <PopoverTrigger>
      <InfoCircleIcon color="gray.400" width="20px" height="20px" />
    </PopoverTrigger>
    <Portal>
      <PopoverContent
        boxShadow="lg"
        borderWidth={0}
        width="auto"
        outline={0}
        _focusVisible={{
          boxShadow: "lg",
        }}
      >
        <PopoverArrow />
        <PopoverBody>{children}</PopoverBody>
      </PopoverContent>
    </Portal>
  </Popover>
);
